var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('titulo-cobranca'),_c('filtro-cobranca',{attrs:{"camposPreenchidos":_vm.camposPreenchidos},on:{"filtrar":_vm.filtrar,"imprimir-carta":_vm.ImprimirCarta,"ver-inadimplencia":_vm.verInadimplencia,"habilitar-botoes":_vm.habilitarBotoes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }